module.exports = __webpack_public_path__ + "static/media/remove.840d7aa0.svg";